<div class="flex flex-col gap-2 {{ alignment }}">
  <span class="text-slate-900 {{ fontWeight }} {{ size }}">{{
    item.config?.title || ""
  }}</span>
</div>
